"use strict";
import { useState, useMemo } from "react";
import { SwapAndLimitContext, SwapContext, initialSwapState, EMPTY_DERIVED_SWAP_INFO } from "state/swap/types";
import { SwapTab } from "uniswap/src/types/screens/interface";
import { FLOW_CHAIN_ID } from "./mockTokenData";
export function AggregatorContextProvider({ children }) {
  const [chainId, setSelectedChainId] = useState(FLOW_CHAIN_ID);
  const currentChainId = useMemo(() => {
    return FLOW_CHAIN_ID;
  }, []);
  const [isUserSelectedToken, setIsUserSelectedToken] = useState(false);
  const [currentTab, setCurrentTab] = useState(SwapTab.Swap);
  const [currencyState, setCurrencyState] = useState({
    inputCurrency: void 0,
    outputCurrency: void 0
  });
  const [swapState, setSwapState] = useState(initialSwapState);
  const swapAndLimitValue = useMemo(
    () => ({
      currencyState,
      setCurrencyState,
      prefilledState: {
        inputCurrency: void 0,
        outputCurrency: void 0
      },
      setSelectedChainId,
      isUserSelectedToken,
      setIsUserSelectedToken,
      currentTab,
      setCurrentTab,
      chainId: currentChainId,
      initialChainId: currentChainId,
      multichainUXEnabled: false,
      isSwapAndLimitContext: false
    }),
    [currentChainId, isUserSelectedToken, currentTab, currencyState]
  );
  const swapValue = useMemo(
    () => ({
      swapState,
      setSwapState,
      derivedSwapInfo: EMPTY_DERIVED_SWAP_INFO
    }),
    [swapState]
  );
  return <SwapAndLimitContext.Provider value={swapAndLimitValue}><SwapContext.Provider value={swapValue}>{children}</SwapContext.Provider></SwapAndLimitContext.Provider>;
}
